import { useEffect, useState } from 'react';
import { EventType } from '~/Models/DTO/Event.model';
import { ILocation } from '~/Models/DTO/Location.models';
import { ITrainer } from '~/Models/DTO/Trainer.models';
import { ExtendedEventGroup } from '../ExtendedEventGroup.model';
import { useOnChangeEventGroupForm } from '../helpers/validation';

export const useEventCreateValidation = ({
  eventType,
  eventGroup,
  setEventGroup,
  trainerList,
  locationList,
}: {
  eventType: EventType;
  eventGroup: ExtendedEventGroup;
  setEventGroup: React.Dispatch<React.SetStateAction<ExtendedEventGroup>>;
  trainerList: ITrainer[];
  locationList: ILocation[];
}) => {
  const [disableSubmit, setDisableSubmit] = useState(false);

  const [isGeneralSectionDone, setIsGeneralSectionDone] = useState(false);
  const [isDetailsSectionDone, setIsDetailsSectionDone] = useState(false);
  const [isScheduleSectionDone, setIsScheduleSectionDone] = useState(false);
  const [isSettingsSectionDone, setIsSettingsSectionDone] = useState(true);

  const validate = useOnChangeEventGroupForm(
    setIsGeneralSectionDone,
    setIsDetailsSectionDone,
    setIsScheduleSectionDone,
    setIsSettingsSectionDone,
    setEventGroup,
    eventType,
  );

  useEffect(() => {
    validate(eventGroup);
  }, []);

  useEffect(() => {
    setDisableSubmit(
      !isGeneralSectionDone ||
        !isDetailsSectionDone ||
        !isScheduleSectionDone ||
        !isSettingsSectionDone,
    );
  }, [isGeneralSectionDone, isDetailsSectionDone, isScheduleSectionDone, isSettingsSectionDone]);

  useEffect(() => {
    if (trainerList && eventGroup.trainerIds?.length === 0) {
      validate({ trainerIds: trainerList.length ? [trainerList[0]?.trainerId] : [] });
    }
  }, [trainerList, locationList]);

  return {
    isGeneralSectionDone,
    isDetailsSectionDone,
    isScheduleSectionDone,
    isSettingsSectionDone,
    setIsScheduleSectionDone,
    disableSubmit,
    validate,
  };
};
